import React from "react";
import ParchmentCard from "./ParchmentCard";
import SanskritSubtitle from "./SanskritSubtitle";
import "./JourneyCard.css";

/**
 * iCRAFTZ Design System · <JourneyCard>
 *
 * The 5-tile primitive used across the Homepage's "How It Works"
 * strip. English label dominant, Sanskrit companion subdued (D26).
 *
 * Props
 * ─────
 * icon           React element (typically a lucide icon or <img/>)
 * english        the primary label (e.g. "Discover")
 * sanskrit       the companion label (e.g. "Jigyasa")
 * subcopy        the small italic line below the label
 * state          'idle' | 'active' | 'disabled'   default 'idle'
 * onClick        click handler; falsy makes the card non-interactive
 * data-testid    passed through
 */
export function JourneyCard({
  icon,
  english,
  sanskrit,
  subcopy,
  state = "idle",
  onClick,
  className = "",
  ...rest
}) {
  const interactive = !!onClick && state !== "disabled";
  return (
    <ParchmentCard
      elevation={state === "active" ? "elevated" : "default"}
      interactive={interactive}
      as={interactive ? "button" : "div"}
      className={[
        "icz-journey-card",
        state === "active" ? "icz-journey-card--active" : "",
        state === "disabled" ? "icz-journey-card--disabled" : "",
        className,
      ].filter(Boolean).join(" ")}
      onClick={interactive ? onClick : undefined}
      aria-disabled={state === "disabled" ? "true" : undefined}
      {...rest}
    >
      {icon ? <div className="icz-journey-card__icon" aria-hidden="true">{icon}</div> : null}
      <div className="icz-journey-card__label">{english}</div>
      {subcopy ? <p className="icz-journey-card__subcopy">{subcopy}</p> : null}
      {sanskrit ? <SanskritSubtitle size="sm">{sanskrit}</SanskritSubtitle> : null}
    </ParchmentCard>
  );
}

export default JourneyCard;
